// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-color: #007bff;
  --primary-hover: #0069d9;
  --success-color: #28a745;
  --success-hover: #218838;
  --error-color: #d93025;
  --error-bg: #f8d7da;
  --error-text: #721c24;
  --gray-color: #6c757d;
  --gray-hover: #565e64;
  --text-dark: #222;
  --text-medium: #333;
  --text-light: #555;
  --text-body-color: #444;
  --border-color: #ccc;
  --modal-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
  --transition-speed: 0.3s;
}

/* Modal Overlay */
.refer-a-lead-modal-overlay {
  position: fixed;
  top: 56px; /* adjust if your navbar height is different */
  left: 0;
  width: 100%;
  height: calc(100% - 56px); /* subtract navbar height */
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn var(--transition-speed) ease-out;
  padding: 16px 0; /* vertical padding helps avoid clipping */
  overflow-y: auto;
}


@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* Modal Container */
.refer-a-lead-modal {
  background: #ffffff;
  width: 90%;
  max-width: 400px;
  padding: 20px;
  border-radius: 10px;
  box-shadow: var(--modal-shadow);
  text-align: left;
  animation: slideUp 0.4s ease-out;
  transform-origin: center bottom;
  max-height: 95vh;
  overflow-y: auto;
  margin: 0 auto; /* Centered on larger view */
  position: relative;
}

@keyframes slideUp {
  from { transform: translateY(20px); opacity: 0.9; }
  to { transform: translateY(0); opacity: 1; }
}

.refer-a-lead-modal .error-toast {
  background-color: var(--error-bg);
  color: var(--error-text);
  border: 1px solid #f5c6cb;
  padding: 10px;
  border-radius: 6px;
  font-size: 0.9rem;
  margin: 5px 0 10px 0;
  text-align: center;
  animation: fadeIn 0.3s ease-out;
}


/* Header */
.refer-a-lead-modal .refer-a-lead-title {
  font-size: 1.3rem;
  font-weight: 600;
  margin-bottom: 8px;
  color: var(--text-dark);
  text-align: center;
}

.refer-a-lead-modal .excite-message {
  font-size: 1rem;
  color: var(--primary-color);
  text-align: center;
  margin-bottom: 12px;
  font-weight: 500;
}

.refer-a-lead-modal .refer-a-lead-subtext {
  font-size: 0.9rem;
  color: var(--text-light);
  margin-bottom: 16px;
  text-align: center;
}

/* Form */
.refer-a-lead-modal .refer-a-lead-form {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.refer-a-lead-modal .form-row-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  align-items: stretch;
}

.refer-a-lead-modal .intent-field select {
  max-width: 100%;
  height: 40px;
}

/* Inputs & Textareas */
.refer-a-lead-modal input,
.refer-a-lead-modal select,
.refer-a-lead-modal textarea {
  padding: 10px;
  font-size: 0.9rem;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  width: 100%;
  box-sizing: border-box;
  transition: border-color var(--transition-speed);
  min-height: 40px;
}

.refer-a-lead-modal input:focus,
.refer-a-lead-modal select:focus,
.refer-a-lead-modal textarea:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 2px rgba(0,123,255,0.2);
}

.refer-a-lead-modal textarea {
  resize: vertical;
  min-height: 60px;
}

/* Labels */
.refer-a-lead-modal label {
  font-size: 0.9rem;
  font-weight: 500;
  margin-bottom: 4px;
  color: var(--text-medium);
}

/* Required Asterisk */
.refer-a-lead-modal .required {
  color: var(--error-color);
  margin-left: 3px;
}

/* Buttons */
.refer-a-lead-modal .form-actions {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 10px;
}

.refer-a-lead-modal .cancel-btn,
.refer-a-lead-modal .submit-btn {
  padding: 10px 16px;
  font-size: 0.9rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all var(--transition-speed);
  min-width: 100px;
}

.refer-a-lead-modal .cancel-btn {
  background-color: var(--gray-color);
  color: white;
}

.refer-a-lead-modal .cancel-btn:hover {
  background-color: var(--gray-hover);
}

.refer-a-lead-modal .submit-btn {
  background-color: var(--primary-color);
  color: white;
}

.refer-a-lead-modal .submit-btn:hover {
  background-color: var(--primary-hover);
}

.refer-a-lead-modal .submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Success Message */
.refer-a-lead-modal .success-content {
  text-align: center;
  padding: 20px 10px;
}

.refer-a-lead-modal .success-title {
  font-size: 1.4rem;
  font-weight: 600;
  margin-bottom: 10px;
  color: var(--success-color);
}

.refer-a-lead-modal .success-message {
  font-size: 1rem;
  color: var(--text-medium);
  margin-bottom: 20px;
  background-color: #e6f4ea;
  padding: 10px;
  border-radius: 6px;
}

.refer-a-lead-modal .success-subtext {
  margin: 8px 0;
  font-size: 14px;
  color: var(--text-body-color);
  line-height: 1.5;
}

.refer-a-lead-modal .success-actions {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-top: 20px;
}

.refer-a-lead-modal .refer-more-btn,
.refer-a-lead-modal .close-btn {
  flex: 1 1;
  max-width: 180px;
  height: 44px;
  font-size: 0.95rem;
  font-weight: 500;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 0.3s ease;
}

.refer-a-lead-modal .refer-more-btn {
  background-color: var(--success-color);
  color: white;
}

.refer-a-lead-modal .refer-more-btn:hover {
  background-color: var(--success-hover);
}

.refer-a-lead-modal .close-btn {
  background-color: var(--gray-color);
  color: white;
}

.refer-a-lead-modal .close-btn:hover {
  background-color: var(--gray-hover);
}

/* Responsive */
@media (max-width: 480px) {
  .refer-a-lead-modal {
    width: 100vw;
    max-width: 100%;
    padding: 20px 16px;
    border-radius: 0;
    height: 100%;
    max-height: 100vh;
    overflow-y: auto; /* ✅ critical */
    padding-top: 40px;
  }

  .refer-a-lead-modal .form-row-grid {
    grid-template-columns: 1fr;
  }

  .refer-a-lead-modal .success-actions {
    flex-direction: column;
    gap: 10px;
  }

  .refer-a-lead-modal .success-actions > button {
    width: 100%;
  }
}

/* Close Button */
.modal-close-btn {
  position: absolute;
  top: 12px;
  right: 12px;
  background: transparent;
  border: none;
  font-size: 1.5rem;
  font-weight: bold;
  color: var(--text-light);
  cursor: pointer;
  z-index: 1001; /* Above modal contents */
}

.modal-close-btn:hover {
  color: var(--error-color); /* Optional red on hover */
}
`, "",{"version":3,"sources":["webpack://./src/components/ReferALeadModal.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,oBAAoB;EACpB,8CAA8C;EAC9C,wBAAwB;AAC1B;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,SAAS,EAAE,8CAA8C;EACzD,OAAO;EACP,WAAW;EACX,yBAAyB,EAAE,2BAA2B;EACtD,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;EACb,kDAAkD;EAClD,eAAe,EAAE,0CAA0C;EAC3D,gBAAgB;AAClB;;;AAGA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;EAChB,gCAAgC;EAChC,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;EAChB,cAAc,EAAE,4BAA4B;EAC5C,kBAAkB;AACpB;;AAEA;EACE,OAAO,2BAA2B,EAAE,YAAY,EAAE;EAClD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,iCAAiC;EACjC,wBAAwB;EACxB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,+BAA+B;AACjC;;;AAGA,WAAW;AACX;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA,uBAAuB;AACvB;;;EAGE,aAAa;EACb,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;;;EAGE,aAAa;EACb,kCAAkC;EAClC,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,SAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,mCAAmC;AACrC;;AAEA,eAAe;AACf;EACE;IACE,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,gBAAgB,EAAE,eAAe;IACjC,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,wBAAwB;EACxB,eAAe;EACf,aAAa,EAAE,yBAAyB;AAC1C;;AAEA;EACE,yBAAyB,EAAE,0BAA0B;AACvD","sourcesContent":[":root {\n  --primary-color: #007bff;\n  --primary-hover: #0069d9;\n  --success-color: #28a745;\n  --success-hover: #218838;\n  --error-color: #d93025;\n  --error-bg: #f8d7da;\n  --error-text: #721c24;\n  --gray-color: #6c757d;\n  --gray-hover: #565e64;\n  --text-dark: #222;\n  --text-medium: #333;\n  --text-light: #555;\n  --text-body-color: #444;\n  --border-color: #ccc;\n  --modal-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);\n  --transition-speed: 0.3s;\n}\n\n/* Modal Overlay */\n.refer-a-lead-modal-overlay {\n  position: fixed;\n  top: 56px; /* adjust if your navbar height is different */\n  left: 0;\n  width: 100%;\n  height: calc(100% - 56px); /* subtract navbar height */\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  z-index: 1000;\n  animation: fadeIn var(--transition-speed) ease-out;\n  padding: 16px 0; /* vertical padding helps avoid clipping */\n  overflow-y: auto;\n}\n\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n/* Modal Container */\n.refer-a-lead-modal {\n  background: #ffffff;\n  width: 90%;\n  max-width: 400px;\n  padding: 20px;\n  border-radius: 10px;\n  box-shadow: var(--modal-shadow);\n  text-align: left;\n  animation: slideUp 0.4s ease-out;\n  transform-origin: center bottom;\n  max-height: 95vh;\n  overflow-y: auto;\n  margin: 0 auto; /* Centered on larger view */\n  position: relative;\n}\n\n@keyframes slideUp {\n  from { transform: translateY(20px); opacity: 0.9; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.refer-a-lead-modal .error-toast {\n  background-color: var(--error-bg);\n  color: var(--error-text);\n  border: 1px solid #f5c6cb;\n  padding: 10px;\n  border-radius: 6px;\n  font-size: 0.9rem;\n  margin: 5px 0 10px 0;\n  text-align: center;\n  animation: fadeIn 0.3s ease-out;\n}\n\n\n/* Header */\n.refer-a-lead-modal .refer-a-lead-title {\n  font-size: 1.3rem;\n  font-weight: 600;\n  margin-bottom: 8px;\n  color: var(--text-dark);\n  text-align: center;\n}\n\n.refer-a-lead-modal .excite-message {\n  font-size: 1rem;\n  color: var(--primary-color);\n  text-align: center;\n  margin-bottom: 12px;\n  font-weight: 500;\n}\n\n.refer-a-lead-modal .refer-a-lead-subtext {\n  font-size: 0.9rem;\n  color: var(--text-light);\n  margin-bottom: 16px;\n  text-align: center;\n}\n\n/* Form */\n.refer-a-lead-modal .refer-a-lead-form {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.refer-a-lead-modal .form-row-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n  align-items: stretch;\n}\n\n.refer-a-lead-modal .intent-field select {\n  max-width: 100%;\n  height: 40px;\n}\n\n/* Inputs & Textareas */\n.refer-a-lead-modal input,\n.refer-a-lead-modal select,\n.refer-a-lead-modal textarea {\n  padding: 10px;\n  font-size: 0.9rem;\n  border: 1px solid var(--border-color);\n  border-radius: 4px;\n  width: 100%;\n  box-sizing: border-box;\n  transition: border-color var(--transition-speed);\n  min-height: 40px;\n}\n\n.refer-a-lead-modal input:focus,\n.refer-a-lead-modal select:focus,\n.refer-a-lead-modal textarea:focus {\n  outline: none;\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 2px rgba(0,123,255,0.2);\n}\n\n.refer-a-lead-modal textarea {\n  resize: vertical;\n  min-height: 60px;\n}\n\n/* Labels */\n.refer-a-lead-modal label {\n  font-size: 0.9rem;\n  font-weight: 500;\n  margin-bottom: 4px;\n  color: var(--text-medium);\n}\n\n/* Required Asterisk */\n.refer-a-lead-modal .required {\n  color: var(--error-color);\n  margin-left: 3px;\n}\n\n/* Buttons */\n.refer-a-lead-modal .form-actions {\n  display: flex;\n  justify-content: center;\n  gap: 12px;\n  margin-top: 10px;\n}\n\n.refer-a-lead-modal .cancel-btn,\n.refer-a-lead-modal .submit-btn {\n  padding: 10px 16px;\n  font-size: 0.9rem;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all var(--transition-speed);\n  min-width: 100px;\n}\n\n.refer-a-lead-modal .cancel-btn {\n  background-color: var(--gray-color);\n  color: white;\n}\n\n.refer-a-lead-modal .cancel-btn:hover {\n  background-color: var(--gray-hover);\n}\n\n.refer-a-lead-modal .submit-btn {\n  background-color: var(--primary-color);\n  color: white;\n}\n\n.refer-a-lead-modal .submit-btn:hover {\n  background-color: var(--primary-hover);\n}\n\n.refer-a-lead-modal .submit-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Success Message */\n.refer-a-lead-modal .success-content {\n  text-align: center;\n  padding: 20px 10px;\n}\n\n.refer-a-lead-modal .success-title {\n  font-size: 1.4rem;\n  font-weight: 600;\n  margin-bottom: 10px;\n  color: var(--success-color);\n}\n\n.refer-a-lead-modal .success-message {\n  font-size: 1rem;\n  color: var(--text-medium);\n  margin-bottom: 20px;\n  background-color: #e6f4ea;\n  padding: 10px;\n  border-radius: 6px;\n}\n\n.refer-a-lead-modal .success-subtext {\n  margin: 8px 0;\n  font-size: 14px;\n  color: var(--text-body-color);\n  line-height: 1.5;\n}\n\n.refer-a-lead-modal .success-actions {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 16px;\n  margin-top: 20px;\n}\n\n.refer-a-lead-modal .refer-more-btn,\n.refer-a-lead-modal .close-btn {\n  flex: 1;\n  max-width: 180px;\n  height: 44px;\n  font-size: 0.95rem;\n  font-weight: 500;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transition: background-color 0.3s ease;\n}\n\n.refer-a-lead-modal .refer-more-btn {\n  background-color: var(--success-color);\n  color: white;\n}\n\n.refer-a-lead-modal .refer-more-btn:hover {\n  background-color: var(--success-hover);\n}\n\n.refer-a-lead-modal .close-btn {\n  background-color: var(--gray-color);\n  color: white;\n}\n\n.refer-a-lead-modal .close-btn:hover {\n  background-color: var(--gray-hover);\n}\n\n/* Responsive */\n@media (max-width: 480px) {\n  .refer-a-lead-modal {\n    width: 100vw;\n    max-width: 100%;\n    padding: 20px 16px;\n    border-radius: 0;\n    height: 100%;\n    max-height: 100vh;\n    overflow-y: auto; /* ✅ critical */\n    padding-top: 40px;\n  }\n\n  .refer-a-lead-modal .form-row-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .refer-a-lead-modal .success-actions {\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .refer-a-lead-modal .success-actions > button {\n    width: 100%;\n  }\n}\n\n/* Close Button */\n.modal-close-btn {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  background: transparent;\n  border: none;\n  font-size: 1.5rem;\n  font-weight: bold;\n  color: var(--text-light);\n  cursor: pointer;\n  z-index: 1001; /* Above modal contents */\n}\n\n.modal-close-btn:hover {\n  color: var(--error-color); /* Optional red on hover */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
